/**
 * Canonical builder for the "Leave a review" CTA URL used across the app.
 *
 * Routes clicks through the backend `/api/emails/review-click/{booking_id}`
 * endpoint (see `backend/routes/emails.py`) which:
 *   1. Records the click in `bookings.review_link_clicked_at` (funnel metric)
 *   2. Increments `review_click_count` and the per-source counter under
 *      `review_click_sources.<source>` — feeds the Review Funnel widget.
 *   3. 302-redirects to `GOOGLE_REVIEW_URL`
 *
 * IMPORTANT — do NOT hard-code `/review/{bookingId}` anywhere in the frontend.
 * That path does NOT exist in `App.js` and produces a black screen. Every
 * review CTA (email template, invoice page, balance-success page) MUST use
 * this helper so the tracking + redirect chain stays in one place.
 *
 * @param {string} bookingId
 * @param {string} [source] — one of "invoice_page" | "balance_success" (and
 *   whatever email templates label themselves as server-side). Anything not
 *   in the backend whitelist collapses to "unknown".
 */
export function buildReviewUrl(bookingId, source) {
  if (!bookingId) return "#";
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const url = `${base.replace(/\/$/, "")}/api/emails/review-click/${bookingId}`;
  return source ? `${url}?src=${encodeURIComponent(source)}` : url;
}
